import React from 'react';
import { useRouter } from 'next/router';
import Layout from '@fuww/library/src/Layout';
import withApollo from '../lib/apollo';
import { useSiteContext } from '../components/SiteContext';
import withQuery from '../lib/withQuery';
import JobApplication from '../components/Jobs/Apply';
import applyForJob from '../lib/queries/jobs/applyForJobQuery.graphql';
import getRedirectJobApply from '../lib/getRedirectJobApply';

const JobApplicationWithQuery = withQuery(JobApplication);

export const CareersJobApplyPage = () => {
  const { id } = useRouter().query;
  const { jobsLocale } = useSiteContext();

  return (
    <JobApplicationWithQuery
      query={applyForJob}
      variables={{ id: Number(id), locales: [jobsLocale] }}
      errorMessage="Error while loading job..."
    />
  );
};

CareersJobApplyPage.getInitialProps = getRedirectJobApply('careers-job-apply');

CareersJobApplyPage.getLayout = (page: React.ReactNode) => (
  <Layout layoutMaxWidth="100vw">{page}</Layout>
);

export default withApollo(CareersJobApplyPage);
